export const generateValues = (maxNum: number, step: number = 5): number[] => {
  const multiples = Array.from({ length: Math.floor(maxNum / step) + 1 }, (_, i) => i * step);
  return maxNum % step === 0 || maxNum < step ? multiples : [...multiples, maxNum];
};
